// extracted by mini-css-extract-plugin
export var textInput = "_jx-0";